// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2l6XT","importantInfo":"styles_importantInfo__2IMw4"};